export const getRecordsPathKey = (pathArray: string[]) => {
  return pathArray.slice(1).join('.'); // remove first item from pathArray as it is the `data` key
};
